import {vesselActions} from "./reducer";
import {IVessel} from "../../varibles/interface";
import {showErrorResponse} from "../../varibles/global";
import {VesselService} from "../../services/vessel";
import {all, call, put, takeEvery} from "@redux-saga/core/effects";


function* getsWatcher(): Generator {
    try {
        const data = yield call(VesselService.gets);
        yield put(vesselActions.getsSuccess(data as IVessel[]));
    } catch (error) {
        yield put(vesselActions.getsFailure())
        showErrorResponse('Get vessel failure', error);
    }
}

function* getVesselContractsWatcher(): Generator {
    try {
        const data = yield call(VesselService.getByContracts);
        yield put(vesselActions.getVesselContractsSuccess(data as IVessel[]));
    } catch (error) {
        yield put(vesselActions.getVesselContractsFailure())
        showErrorResponse('Get vessel failure', error);
    }
}


export default function* vesselSaga() {
    yield all([
        takeEvery(vesselActions.gets.type, getsWatcher),
        takeEvery(vesselActions.getVesselContracts.type, getVesselContractsWatcher),
    ])
}
